// extracted by mini-css-extract-plugin
module.exports = {"group":"index-module__group___tRxXQ"};